import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-order-line-cancel-cause-lang',
  templateUrl: './order-line-cancel-cause-lang.component.html',
  styleUrls: ['./order-line-cancel-cause-lang.component.css']
})
export class OrderLineCancelCauseLangComponent implements OnInit {
    orderLineCancelCauseKeyno;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.orderLineCancelCauseKeyno = this.stateService.getStateParams()['orderlinecancelcause_keyno'];
    }

    private async loadLanguages() {
        if (!!this.orderLineCancelCauseKeyno) {
            this.inputListLanguages = await this.datatask.Post(3329, { orderlinecancelcause_keyno: this.orderLineCancelCauseKeyno });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(3330, { records: this.inputListLanguages });

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    orderlinecancelcause_keyno: number;
    orderlinecancelcauselang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('orderLineCancelCauseLang', {
//        templateUrl: 'views/components/views/orderLineCancelCauseLang/orderLineCancelCauseLang.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'orderLineCancelCauseLangService', function ($stateParams, stateService, orderLineCancelCauseLangService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let orderLineCancelCauseKeyno = $stateParams.orderlinecancelcause_keyno;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await orderLineCancelCauseLangService.listOrderLineCancelCauseLanguages({ orderlinecancelcause_keyno: orderLineCancelCauseKeyno });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                orderLineCancelCauseLangService.saveObj({ records: vm.model.inputListLanguages }).then(() => {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, () => vm.model.lockedSave = false);
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
